import { TabType } from '@/constants/subscription';
import { atom } from 'jotai';

/**
 * 会员商品组入口标识
 */
export const subEntranceBizCodeAtom = atom<string>('');

/**
 * 当前tab，商品类型：会员商拍/美豆商品/抠图商品
 * 默认是URL透传控制的default_tab值
 */
export const curTabAtom = atom<TabType>(TabType.SUB);
